<template>
  <div>
    <h1>Adicionar Veículo</h1>
    <v-form ref="formCreateVehicle" @submit.prevent="save()">
      <v-row>
        <v-col cols="12" md="3">
          <v-text-field
            label="Placa"
            v-model="vehicle.plate"
            :rules="requiredRules"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            label="KM"
            v-model="vehicle.km"
            :rules="requiredRules"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="3">
          <v-select
            label="Combustível"
            :items="fuels"
            item-text="name"
            item-value="id"
            v-model="vehicle.fuel_id"
            :loading="loadFuels"
          ></v-select>
        </v-col>
        <v-col cols="12" md="3">
          <v-btn color="secondary" :loading="saving" class="mt-2" type="submit"
            >Salvar</v-btn
          >
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import http from "@/modules/http";
export default {
  mounted() {
    this.getFuels();
  },
  data() {
    return {
      vehicle: {
        plate: "",
        km: "",
        fuel_id: "",
      },
      saving: false,
      requiredRules: [(v) => !!v || "Este campo é obrigatório"],
      fuels: [],
      loadFuels: false,
    };
  },
  methods: {
    cleanForm() {
      this.vehicle = {
        plate: "",
        km: "",
        fuel_id: "",
      };
    },
    getFuels() {
      this.loadFuels = true;
      http
        .get("api/fuels")
        .then((res) => {
          this.loadFuels = false;
          this.fuels = res.data;
        })
        .catch((err) => {
          this.loadFuels = false;
          console.log(err);
        });
    },
    save() {
      if (this.$refs.formCreateVehicle.validate()) {
        this.saving = true;
        http
          .post("api/vehicles", this.vehicle)
          .then((res) => {
            this.$side({
              type: "success",
              msg: "Salvo com sucesso",
              duration: 4000,
            });
            this.cleanForm();
            this.$refs.formCreateVehicle.reset();
            this.saving = false;
            this.$emit("vehicleSaved", true);
          })
          .catch((err) => {
            console.log(err);
            this.saving = false;
          });
      }
    },
  },
};
</script>